module.exports = __webpack_public_path__ + "img/bg5.ec08c038.jpg";